// import React from 'react'

import img1 from '../../media/images/GurugramContent1.jpg'
import img2 from '../../media/images/GurugramContent2.jpg'

const LocationContent = () => {
  return (
    <div>

        <div className="location-content">
        <div className="location-content-main">
        <div className="location-content-main-img">
            <img src={img1} title="Pet Groomers Near Me" alt="offer-imh" />
        </div>

            
            
        <div className="location-content-section">
        <h3 className="location-content-heading">Pet Grooming in <span>Gurgaon</span> – Home <span>Dog</span> & <span>Cat</span> Grooming</h3>
        <div className="location-content-text">Looking for pet grooming in Gurgaon? FluffyTouch brings dog grooming near me and cat grooming at home straight to your door. No more dragging your furry buddy to a salon—our pro groomers make your pet look and feel amazing right at home. Grooming isn’t just about looks; it keeps your pet’s skin healthy, cuts down on fur mess, and makes them a happy camper!</div>

        <div className="location-content-image">
            <img src={img2} title="Pet Groomers Near Me" alt="offer-imh" />
        </div>


<section>

        <div className="location-content-sub-heading">Why FluffyTouch is Gurgaon’s Go-To for Pet Grooming</div>
        <div className="location-content-text">
            <ul>
                <li><b>Chill at Home:</b> Your pet stays relaxed with no car rides or salon stress.</li>
                <li><b>Rockstar Groomers:</b> Our team knows every breed, from rowdy Labs to fussy Persians.</li>
                <li><b>Made for Your Pet:</b> Custom dog grooming and cat grooming to match their vibe.</li>

            </ul>
        </div>


        <div className="location-content-sub-heading">What We Offer for Pet Grooming in Gurgaon</div>
        <div className="location-content-text">

        Our at-home pet grooming services cover it all:
        <ul>

<li>Dog Bath & Shine: Deep wash, brushing, and drying to zap dirt and smells.</li>
<li>Cat Pamper Session: Soft brushing, nail clips, and gentle baths for kitties.</li>
<li>Doggy Haircuts: Cool, breed-specific trims that scream style.</li>
<li>Paw & Nail Love: Safe nail trimming with a comfy paw massage.</li>
<li>Ear Fresh-Up: Gentle cleaning to keep infections away.</li>
        </ul>
        We use pet-friendly products and sparkling clean tools every time.

            
        </div>


        <div className="location-content-sub-heading">How to Book Pet Grooming Near Me in Gurgaon</div>
        <div className="location-content-text">
            <ol>
                <li>Hop on our website to see if we’re in your area.</li>
                <li>Pick a pet grooming package that fits your furball.</li>
                <li>Book via website or WhatsApp in a jiffy.</li>
                <li>Sit back—our groomer shows up to work their magic!</li>

            </ol>
        </div>


        <div className="location-content-sub-heading">Why Gurgaon Pet Parents Love FluffyTouch</div>
        <div className="location-content-text">

            <ul>
                <li><b>Pro Skills:</b> Years of taming fluffy dogs and sassy cats.</li>
                <li><b>Raving Fans:</b> Loads of happy clients giving us 5 stars.</li>
                <li><b>Full Pet Care:</b> Grooming, training, and vet tips, all in one place.</li>
                <li><b>Wallet-Friendly:</b> Sweet deals for regular or group bookings.</li>
            </ul>
            
        </div>

</section>

        <div className="location-content-sub-heading">Get Your Pet Groomed in Gurgaon Today!</div>
        <div className="location-content-text">
        Make your dog or cat the talk of the town with FluffyTouch’s pet grooming at home in Gurgaon. Book now for a squeaky-clean, tail-wagging pet!
        📞 Call Us or 💬 WhatsApp Now to lock in a slot!
        </div>


        <div className="location-content-sub-heading"></div>
        <div className="location-content-text"></div>

        </div>

        </div>

        </div>
        
        
    </div>
  )
}

export default LocationContent